// extracted by css-extract-rspack-plugin
export default {"tabsList":"tabsList-otB775","tab":"tab-jo61fR","indicator":"indicator-nJQfvV"};